import { useB3Lang } from '@b3/lang';
import { B3Tag } from '@/components';
import { getOrderCancellationStatus } from '@/pages/order/shared/getOrderCancellationStatus';

interface OrderCancellationStatusProps {
  code: string | number;
  text?: string;
}

export default function OrderCancellationStatus({ code, text }: OrderCancellationStatusProps) {
  const b3Lang = useB3Lang();
  const status = getOrderCancellationStatus(code);

  // console.log('found status:', code, status);

  if (!status) return null;

  const translatedStatus = b3Lang(status.translationKey) || text || status.label;

  return (
    <B3Tag color={status.color}>
      {translatedStatus}
    </B3Tag>
  );
}